export const measures = {
  "options": {
    "area": [
      {
        "label": "Afghanistan",
        "value": "AF"
      },
      {
        "label": "Åland Islands",
        "value": "AX"
      },
      {
        "label": "Albania",
        "value": "AL"
      },
      {
        "label": "Algeria",
        "value": "DZ"
      },
      {
        "label": "American Samoa",
        "value": "AS"
      },
      {
        "label": "Andorra",
        "value": "AD"
      },
      {
        "label": "Angola",
        "value": "AO"
      },
      {
        "label": "Anguilla",
        "value": "AI"
      },
      {
        "label": "Antarctica",
        "value": "AQ"
      },
      {
        "label": "Antigua and Barbuda",
        "value": "AG"
      },
      {
        "label": "Argentina",
        "value": "AR"
      },
      {
        "label": "Armenia",
        "value": "AM"
      },
      {
        "label": "Aruba",
        "value": "AW"
      },
      {
        "label": "Australia",
        "value": "AU"
      },
      {
        "label": "Austria",
        "value": "AT"
      },
      {
        "label": "Azerbaijan",
        "value": "AZ"
      },
      {
        "label": "Bahamas",
        "value": "BS"
      },
      {
        "label": "Bahrain",
        "value": "BH"
      },
      {
        "label": "Bangladesh",
        "value": "BD"
      },
      {
        "label": "Barbados",
        "value": "BB"
      },
      {
        "label": "Belarus",
        "value": "BY"
      },
      {
        "label": "Belgium",
        "value": "BE"
      },
      {
        "label": "Belize",
        "value": "BZ"
      },
      {
        "label": "Benin",
        "value": "BJ"
      },
      {
        "label": "Bermuda",
        "value": "BM"
      },
      {
        "label": "Bhutan",
        "value": "BT"
      },
      {
        "label": "Bolivia (Plurinational State of)",
        "value": "BO"
      },
      {
        "label": "Bonaire, Sint Eustatius and Saba",
        "value": "BQ"
      },
      {
        "label": "Bosnia and Herzegovina",
        "value": "BA"
      },
      {
        "label": "Botswana",
        "value": "BW"
      },
      {
        "label": "Bouvet Island",
        "value": "BV"
      },
      {
        "label": "Brazil",
        "value": "BR"
      },
      {
        "label": "British Indian Ocean Territory",
        "value": "IO"
      },
      {
        "label": "Brunei Darussalam",
        "value": "BN"
      },
      {
        "label": "Bulgaria",
        "value": "BG"
      },
      {
        "label": "Burkina Faso",
        "value": "BF"
      },
      {
        "label": "Burundi",
        "value": "BI"
      },
      {
        "label": "Cabo Verde",
        "value": "CV"
      },
      {
        "label": "Cambodia",
        "value": "KH"
      },
      {
        "label": "Cameroon",
        "value": "CM"
      },
      {
        "label": "Canada",
        "value": "CA"
      },
      {
        "label": "Cayman Islands",
        "value": "KY"
      },
      {
        "label": "Central African Republic",
        "value": "CF"
      },
      {
        "label": "Chad",
        "value": "TD"
      },
      {
        "label": "Chile",
        "value": "CL"
      },
      {
        "label": "China",
        "value": "CN"
      },
      {
        "label": "Christmas Island",
        "value": "CX"
      },
      {
        "label": "Cocos (Keeling) Islands",
        "value": "CC"
      },
      {
        "label": "Colombia",
        "value": "CO"
      },
      {
        "label": "Comoros",
        "value": "KM"
      },
      {
        "label": "Congo",
        "value": "CG"
      },
      {
        "label": "Cook Islands",
        "value": "CK"
      },
      {
        "label": "Costa Rica",
        "value": "CR"
      },
      {
        "label": "Croatia",
        "value": "HR"
      },
      {
        "label": "Cuba",
        "value": "CU"
      },
      {
        "label": "Curaçao",
        "value": "CW"
      },
      {
        "label": "Cyprus",
        "value": "CY"
      },
      {
        "label": "Czechia",
        "value": "CZ"
      },
      {
        "label": "Democratic Republic of the Congo",
        "value": "CD"
      },
      {
        "label": "Denmark",
        "value": "DK"
      },
      {
        "label": "Djibouti",
        "value": "DJ"
      },
      {
        "label": "Dominica",
        "value": "DM"
      },
      {
        "label": "Dominican Republic",
        "value": "DO"
      },
      {
        "label": "Ecuador",
        "value": "EC"
      },
      {
        "label": "Egypt",
        "value": "EG"
      },
      {
        "label": "El Salvador",
        "value": "SV"
      },
      {
        "label": "Equatorial Guinea",
        "value": "GQ"
      },
      {
        "label": "Eritrea",
        "value": "ER"
      },
      {
        "label": "Estonia",
        "value": "EE"
      },
      {
        "label": "Eswatini",
        "value": "SZ"
      },
      {
        "label": "Ethiopia",
        "value": "ET"
      },
      {
        "label": "Falkland Islands (Malvinas)",
        "value": "FK"
      },
      {
        "label": "Faroe Islands",
        "value": "FO"
      },
      {
        "label": "Fiji",
        "value": "FJ"
      },
      {
        "label": "Finland",
        "value": "FI"
      },
      {
        "label": "France",
        "value": "FR"
      },
      {
        "label": "French Guiana",
        "value": "GF"
      },
      {
        "label": "French Polynesia",
        "value": "PF"
      },
      {
        "label": "French Southern Territories",
        "value": "TF"
      },
      {
        "label": "Gabon",
        "value": "GA"
      },
      {
        "label": "Gambia",
        "value": "GM"
      },
      {
        "label": "Georgia",
        "value": "GE"
      },
      {
        "label": "Germany",
        "value": "DE"
      },
      {
        "label": "Ghana",
        "value": "GH"
      },
      {
        "label": "Gibraltar",
        "value": "GI"
      },
      {
        "label": "Greece",
        "value": "GR"
      },
      {
        "label": "Greenland",
        "value": "GL"
      },
      {
        "label": "Grenada",
        "value": "GD"
      },
      {
        "label": "Guadeloupe",
        "value": "GP"
      },
      {
        "label": "Guam",
        "value": "GU"
      },
      {
        "label": "Guatemala",
        "value": "GT"
      },
      {
        "label": "Guernsey",
        "value": "GG"
      },
      {
        "label": "Guinea",
        "value": "GN"
      },
      {
        "label": "Guinea-Bissau",
        "value": "GW"
      },
      {
        "label": "Guyana",
        "value": "GY"
      },
      {
        "label": "Haiti",
        "value": "HT"
      },
      {
        "label": "Heard Island and McDonald Islands",
        "value": "HM"
      },
      {
        "label": "Holy See",
        "value": "VA"
      },
      {
        "label": "Honduras",
        "value": "HN"
      },
      {
        "label": "Hong Kong",
        "value": "HK"
      },
      {
        "label": "Hungary",
        "value": "HU"
      },
      {
        "label": "Iceland",
        "value": "IS"
      },
      {
        "label": "India",
        "value": "IN"
      },
      {
        "label": "Indonesia",
        "value": "ID"
      },
      {
        "label": "Iran (Islamic Republic of)",
        "value": "IR"
      },
      {
        "label": "Iraq",
        "value": "IQ"
      },
      {
        "label": "Ireland",
        "value": "IE"
      },
      {
        "label": "Isle of Man",
        "value": "IM"
      },
      {
        "label": "Israel",
        "value": "IL"
      },
      {
        "label": "Italy",
        "value": "IT"
      },
      {
        "label": "Ivory Coast",
        "value": "CI"
      },
      {
        "label": "Jamaica",
        "value": "JM"
      },
      {
        "label": "Japan",
        "value": "JP"
      },
      {
        "label": "Jersey",
        "value": "JE"
      },
      {
        "label": "Jordan",
        "value": "JO"
      },
      {
        "label": "Kazakhstan",
        "value": "KZ"
      },
      {
        "label": "Kenya",
        "value": "KE"
      },
      {
        "label": "Kiribati",
        "value": "KI"
      },
      {
        "label": "Korea (Democratic People's Republic of)",
        "value": "KP"
      },
      {
        "label": "Korea, Republic of",
        "value": "KR"
      },
      {
        "label": "Kuwait",
        "value": "KW"
      },
      {
        "label": "Kyrgyzstan",
        "value": "KG"
      },
      {
        "label": "Lao People's Democratic Republic",
        "value": "LA"
      },
      {
        "label": "Latvia",
        "value": "LV"
      },
      {
        "label": "Lebanon",
        "value": "LB"
      },
      {
        "label": "Lesotho",
        "value": "LS"
      },
      {
        "label": "Liberia",
        "value": "LR"
      },
      {
        "label": "Libya",
        "value": "LY"
      },
      {
        "label": "Liechtenstein",
        "value": "LI"
      },
      {
        "label": "Lithuania",
        "value": "LT"
      },
      {
        "label": "Luxembourg",
        "value": "LU"
      },
      {
        "label": "Macao",
        "value": "MO"
      },
      {
        "label": "Madagascar",
        "value": "MG"
      },
      {
        "label": "Malawi",
        "value": "MW"
      },
      {
        "label": "Malaysia",
        "value": "MY"
      },
      {
        "label": "Maldives",
        "value": "MV"
      },
      {
        "label": "Mali",
        "value": "ML"
      },
      {
        "label": "Malta",
        "value": "MT"
      },
      {
        "label": "Marshall Islands",
        "value": "MH"
      },
      {
        "label": "Martinique",
        "value": "MQ"
      },
      {
        "label": "Mauritania",
        "value": "MR"
      },
      {
        "label": "Mauritius",
        "value": "MU"
      },
      {
        "label": "Mayotte",
        "value": "YT"
      },
      {
        "label": "Mexico",
        "value": "MX"
      },
      {
        "label": "Micronesia (Federated States of)",
        "value": "FM"
      },
      {
        "label": "Moldova, Republic of",
        "value": "MD"
      },
      {
        "label": "Monaco",
        "value": "MC"
      },
      {
        "label": "Mongolia",
        "value": "MN"
      },
      {
        "label": "Montenegro",
        "value": "ME"
      },
      {
        "label": "Montserrat",
        "value": "MS"
      },
      {
        "label": "Morocco",
        "value": "MA"
      },
      {
        "label": "Mozambique",
        "value": "MZ"
      },
      {
        "label": "Myanmar",
        "value": "MM"
      },
      {
        "label": "Namibia",
        "value": "NA"
      },
      {
        "label": "Nauru",
        "value": "NR"
      },
      {
        "label": "Nepal",
        "value": "NP"
      },
      {
        "label": "Netherlands",
        "value": "NL"
      },
      {
        "label": "New Caledonia",
        "value": "NC"
      },
      {
        "label": "New Zealand",
        "value": "NZ"
      },
      {
        "label": "Nicaragua",
        "value": "NI"
      },
      {
        "label": "Niger",
        "value": "NE"
      },
      {
        "label": "Nigeria",
        "value": "NG"
      },
      {
        "label": "Niue",
        "value": "NU"
      },
      {
        "label": "Norfolk Island",
        "value": "NF"
      },
      {
        "label": "North Macedonia",
        "value": "MK"
      },
      {
        "label": "Northern Mariana Islands",
        "value": "MP"
      },
      {
        "label": "Norway",
        "value": "NO"
      },
      {
        "label": "Oman",
        "value": "OM"
      },
      {
        "label": "Pakistan",
        "value": "PK"
      },
      {
        "label": "Palau",
        "value": "PW"
      },
      {
        "label": "Palestine, State of",
        "value": "PS"
      },
      {
        "label": "Panama",
        "value": "PA"
      },
      {
        "label": "Papua New Guinea",
        "value": "PG"
      },
      {
        "label": "Paraguay",
        "value": "PY"
      },
      {
        "label": "Peru",
        "value": "PE"
      },
      {
        "label": "Philippines",
        "value": "PH"
      },
      {
        "label": "Pitcairn",
        "value": "PN"
      },
      {
        "label": "Poland",
        "value": "PL"
      },
      {
        "label": "Portugal",
        "value": "PT"
      },
      {
        "label": "Puerto Rico",
        "value": "PR"
      },
      {
        "label": "Qatar",
        "value": "QA"
      },
      {
        "label": "Réunion",
        "value": "RE"
      },
      {
        "label": "Romania",
        "value": "RO"
      },
      {
        "label": "Russian Federation",
        "value": "RU"
      },
      {
        "label": "Rwanda",
        "value": "RW"
      },
      {
        "label": "Saint Barthélemy",
        "value": "BL"
      },
      {
        "label": "Saint Helena, Ascension and Tristan da Cunha",
        "value": "SH"
      },
      {
        "label": "Saint Kitts and Nevis",
        "value": "KN"
      },
      {
        "label": "Saint Lucia",
        "value": "LC"
      },
      {
        "label": "Saint Martin (French part)",
        "value": "MF"
      },
      {
        "label": "Saint Pierre and Miquelon",
        "value": "PM"
      },
      {
        "label": "Saint Vincent and the Grenadines",
        "value": "VC"
      },
      {
        "label": "Samoa",
        "value": "WS"
      },
      {
        "label": "San Marino",
        "value": "SM"
      },
      {
        "label": "Sao Tome and Principe",
        "value": "ST"
      },
      {
        "label": "Saudi Arabia",
        "value": "SA"
      },
      {
        "label": "Senegal",
        "value": "SN"
      },
      {
        "label": "Serbia",
        "value": "RS"
      },
      {
        "label": "Seychelles",
        "value": "SC"
      },
      {
        "label": "Sierra Leone",
        "value": "SL"
      },
      {
        "label": "Singapore",
        "value": "SG"
      },
      {
        "label": "Sint Maarten (Dutch part)",
        "value": "SX"
      },
      {
        "label": "Slovakia",
        "value": "SK"
      },
      {
        "label": "Slovenia",
        "value": "SI"
      },
      {
        "label": "Solomon Islands",
        "value": "SB"
      },
      {
        "label": "Somalia",
        "value": "SO"
      },
      {
        "label": "South Africa",
        "value": "ZA"
      },
      {
        "label": "South Georgia and the South Sandwich Islands",
        "value": "GS"
      },
      {
        "label": "South Sudan",
        "value": "SS"
      },
      {
        "label": "Spain",
        "value": "ES"
      },
      {
        "label": "Sri Lanka",
        "value": "LK"
      },
      {
        "label": "Sudan",
        "value": "SD"
      },
      {
        "label": "Suriname",
        "value": "SR"
      },
      {
        "label": "Svalbard and Jan Mayen",
        "value": "SJ"
      },
      {
        "label": "Sweden",
        "value": "SE"
      },
      {
        "label": "Switzerland",
        "value": "CH"
      },
      {
        "label": "Syrian Arab Republic",
        "value": "SY"
      },
      {
        "label": "Taiwan, Province of China",
        "value": "TW"
      },
      {
        "label": "Tajikistan",
        "value": "TJ"
      },
      {
        "label": "Tanzania, United Republic of",
        "value": "TZ"
      },
      {
        "label": "Thailand",
        "value": "TH"
      },
      {
        "label": "Timor-Leste",
        "value": "TL"
      },
      {
        "label": "Togo",
        "value": "TG"
      },
      {
        "label": "Tokelau",
        "value": "TK"
      },
      {
        "label": "Tonga",
        "value": "TO"
      },
      {
        "label": "Trinidad and Tobago",
        "value": "TT"
      },
      {
        "label": "Tunisia",
        "value": "TN"
      },
      {
        "label": "Turkey",
        "value": "TR"
      },
      {
        "label": "Turkmenistan",
        "value": "TM"
      },
      {
        "label": "Turks and Caicos Islands",
        "value": "TC"
      },
      {
        "label": "Tuvalu",
        "value": "TV"
      },
      {
        "label": "Uganda",
        "value": "UG"
      },
      {
        "label": "Ukraine",
        "value": "UA"
      },
      {
        "label": "United Arab Emirates",
        "value": "AE"
      },
      {
        "label": "United Kingdom of Great Britain and Northern Ireland",
        "value": "GB"
      },
      {
        "label": "United States Minor Outlying Islands",
        "value": "UM"
      },
      {
        "label": "United States of America",
        "value": "US"
      },
      {
        "label": "Uruguay",
        "value": "UY"
      },
      {
        "label": "Uzbekistan",
        "value": "UZ"
      },
      {
        "label": "Vanuatu",
        "value": "VU"
      },
      {
        "label": "Venezuela (Bolivarian Republic of)",
        "value": "VE"
      },
      {
        "label": "Viet Nam",
        "value": "VN"
      },
      {
        "label": "Virgin Islands (British)",
        "value": "VG"
      },
      {
        "label": "Virgin Islands (U.S.)",
        "value": "VI"
      },
      {
        "label": "Wallis and Futuna",
        "value": "WF"
      },
      {
        "label": "Western Sahara",
        "value": "EH"
      },
      {
        "label": "Yemen",
        "value": "YE"
      },
      {
        "label": "Zambia",
        "value": "ZM"
      },
      {
        "label": "Zimbabwe",
        "value": "ZW"
      }
    ],
    "locationType": [
      {
        "label": "Mine Site",
        "value": "mineSite",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "scl",
              "event"
            ]
          }
        ]
      },
      {
        "label": "Village",
        "value": "village",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "scl",
              "event"
            ]
          }
        ]
      },
      {
        "label": "Town / City",
        "value": "town",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "scl",
              "event"
            ]
          }
        ]
      },
      {
        "label": "Road",
        "value": "road",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "scl",
              "event"
            ]
          }
        ]
      },
      {
        "label": "Warehouse",
        "value": "warehouse",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "scl",
              "event"
            ]
          }
        ]
      },
      {
        "label": "Market / trading centre",
        "value": "marketTradingCentre",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "scl",
              "event"
            ]
          }
        ]
      },
      {
        "label": "Factory / Plant",
        "value": "factoryOrPlant",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "scl",
              "event"
            ]
          }
        ]
      },
      {
        "label": "Farm",
        "value": "farm",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "event"
            ]
          }
        ]
      },
      {
        "label": "Forest",
        "value": "forest",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "event"
            ]
          }
        ]
      },
      {
        "label": "Field",
        "value": "field",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "event"
            ]
          }
        ]
      },
      {
        "label": "Lake",
        "value": "lake",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "event"
            ]
          }
        ]
      },
      {
        "label": "River",
        "value": "river",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "event"
            ]
          }
        ]
      },
      {
        "label": "Other",
        "value": "other",
        "filters": [
          {
            "name": "locCategory",
            "condition": "includes",
            "value": [
              "event"
            ]
          }
        ]
      }
    ],
    "riskCategory": [
      {
        "label": "Legality",
        "value": "legality"
      },
      {
        "label": "Human Rights",
        "value": "humanRights"
      },
      {
        "label": "Conflict & Security",
        "value": "conflictSecurity"
      },
      {
        "label": "Environment & Natural Resources",
        "value": "environment"
      },
      {
        "label": "Health & Safety",
        "value": "healthSafety"
      },
      {
        "label": "Community & Society",
        "value": "communitySociety"
      }
    ],
    "riskType": [
      {
        "label": "Illegality of the sector",
        "group": "legality",
        "value": "illegalityOfTheSector",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Illegal mining operations",
        "group": "legality",
        "value": "illegalMiningOperations",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Illegal supply chain actors",
        "group": "legality",
        "value": "illegalSupplyChainActors",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Contradictory claims",
        "group": "legality",
        "value": "contradictoryClaims",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Missing evidence",
        "group": "legality",
        "value": "missingEvidence",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Money laundering",
        "group": "legality",
        "value": "moneyLaundering",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Issue with payments to government",
        "group": "legality",
        "value": "issueWithGovernmentPayments",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Extortion / Illegal taxation",
        "group": "legality",
        "value": "extortion",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Presence and interference of public or private security forces",
        "group": "legality",
        "value": "presenceSecurityForces",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Illegal control",
        "group": "legality",
        "value": "illegalControl",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Illegal trade",
        "group": "legality",
        "value": "illegalTrade",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Corruption, bribery and facilitation",
        "group": "legality",
        "value": "corruption",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "label": "Supply chain contamination",
        "group": "legality",
        "value": "contamination",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "legality"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Violence against civilians",
        "value": "violenceAgainstCivilians",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Abduction / kidnapping of civilians",
        "value": "kidnappingOfCivilians",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Clash / Confrontation between groups",
        "value": "groupClash",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Armed group presence or incursion",
        "value": "armedGroupPresence",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Identity-based conflict or tension",
        "value": "identityBasedConflictOrTension",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "War crime",
        "value": "warCrime",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Crime against humanity or genocide",
        "value": "crimeAgainstHumanityOrGenocide",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Terrorism",
        "value": "terrorism",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Destruction of property",
        "value": "destructionOfProperty",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Pillage / Looting of property and /or goods",
        "value": "pillageLootingOfPropertyOrGoods",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Theft",
        "value": "theft",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Riot / demonstration",
        "value": "riotDemonstrations",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Remote violence",
        "value": "remoteViolence",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Political repression",
        "value": "politicalRepression",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "conflictSecurity",
        "label": "Sexual and gender-based violence",
        "value": "sexualGenderBasedViolence",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "conflictSecurity"
            ]
          }
        ]
      },
      {
        "group": "humanRights",
        "label": "Torture",
        "value": "torture",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "humanRightsAbuse"
            ]
          }
        ]
      },
      {
        "group": "humanRights",
        "label": "Cruel, inhumane, degrading treatment",
        "value": "cruel",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "humanRightsAbuse"
            ]
          }
        ]
      },
      {
        "group": "humanRights",
        "label": "Abusive disciplinary practices",
        "value": "abusiveDisciplinary",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "humanRightsAbuse"
            ]
          }
        ]
      },
      {
        "group": "humanRights",
        "label": "Discrimination",
        "value": "discrimination",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "humanRightsAbuse"
            ]
          }
        ]
      },
      {
        "group": "humanRights",
        "label": "Forced labour",
        "value": "forcedLabour",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "humanRightsAbuse"
            ]
          }
        ]
      },
      {
        "group": "humanRights",
        "label": "Child labour",
        "value": "childLabour",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "humanRightsAbuse"
            ]
          }
        ]
      },
      {
        "group": "humanRights",
        "label": "Sexual exploitation",
        "value": "sexualExploitation",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "humanRightsAbuse"
            ]
          }
        ]
      },
      {
        "group": "humanRights",
        "label": "Human trafficking",
        "value": "humanTrafficking",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "humanRightsAbuse"
            ]
          }
        ]
      },
      {
        "group": "healthSafety",
        "label": "Infrastructure reliability and operational safety",
        "value": "infrastructureReliability",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "healthSafety"
            ]
          }
        ]
      },
      {
        "group": "healthSafety",
        "label": "Machines reliability and operational safety",
        "value": "machineReliability",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "healthSafety"
            ]
          }
        ]
      },
      {
        "group": "healthSafety",
        "label": "Explosives and blasting",
        "value": "explosive",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "healthSafety"
            ]
          }
        ]
      },
      {
        "group": "healthSafety",
        "label": "Mercury use and production",
        "value": "mercuryUse",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "healthSafety"
            ]
          }
        ]
      },
      {
        "group": "healthSafety",
        "label": "Exposure to hazardous, harmful or toxic substances",
        "value": "exposureToHazardous",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "healthSafety"
            ]
          }
        ]
      },
      {
        "group": "healthSafety",
        "label": "Exposure to radioactivity",
        "value": "exposureToRadioactivity",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "healthSafety"
            ]
          }
        ]
      },
      {
        "group": "healthSafety",
        "label": "Personal Protective Equipment (PPE)",
        "value": "ppe",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "healthSafety"
            ]
          }
        ]
      },
      {
        "group": "environment",
        "label": "Misalignment between conservation goals and community priorities",
        "value": "conversationAligment",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "environment",
              "naturalResources"
            ]
          }
        ]
      },
      {
        "group": "environment",
        "label": "Post-mining reclamation and sustainable land use",
        "value": "sustainableLand",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "environment",
              "naturalResources"
            ]
          }
        ]
      },
      {
        "group": "environment",
        "label": "Ecosystem degradation",
        "value": "ecosystemProtection",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "environment",
              "naturalResources"
            ]
          }
        ]
      },
      {
        "group": "environment",
        "label": "Forest health and sustainability",
        "value": "forestHealth",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "environment",
              "naturalResources"
            ]
          }
        ]
      },
      {
        "group": "environment",
        "label": "Wastewater contamination and water quality",
        "value": "wastewaterContamination",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "environment",
              "naturalResources"
            ]
          }
        ]
      },
      {
        "group": "environment",
        "label": "Soil pollution and contamination",
        "value": "soilPollution",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "environment",
              "naturalResources"
            ]
          }
        ]
      },
      {
        "group": "environment",
        "label": "Air pollution",
        "value": "airPollution",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "environment",
              "naturalResources"
            ]
          }
        ]
      },
      {
        "group": "environment",
        "label": "Landslides",
        "value": "landslide",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "environment",
              "naturalResources"
            ]
          }
        ]
      },
      {
        "group": "environment",
        "label": "Water flooding",
        "value": "waterFlooding",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "environment",
              "naturalResources"
            ]
          }
        ]
      },
      {
        "group": "environment",
        "label": "Earthquake",
        "value": "earthquake",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "environment",
              "naturalResources"
            ]
          }
        ]
      },
      {
        "group": "communitySociety",
        "label": "Poor coexistence between local community and mineral extraction activities",
        "value": "localAndMineralActivities",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "communitySociety"
            ]
          }
        ]
      },
      {
        "group": "communitySociety",
        "label": "Absence of local participation in decision making",
        "value": "localParticipation",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "communitySociety"
            ]
          }
        ]
      },
      {
        "group": "communitySociety",
        "label": "Resource conflicts regarding land use",
        "value": "resourceConflictsForLand",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "communitySociety"
            ]
          }
        ]
      },
      {
        "group": "communitySociety",
        "label": "Resource conflicts regarding water use",
        "value": "resourceConflictsForWater",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "communitySociety"
            ]
          }
        ]
      },
      {
        "group": "communitySociety",
        "label": "ASM-LSM Cohabitation ",
        "value": "asmLsmCohabitation",
        "filters": [
          {
            "name": "associatedRisk",
            "condition": "includes",
            "value": [
              "communitySociety"
            ]
          }
        ]
      }
    ],
    "riskMeasures": [
      {
        "label": "Stakeholder Engagement",
        "value": "stakeholderEngagement"
      },
      {
        "label": "Education & Training",
        "value": "education&Training"
      },
      {
        "label": "Site visit / assessment",
        "value": "siteAssessment",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      },
      {
        "label": "Monitoring",
        "value": "monitoring",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      },
      {
        "label": "Due Diligence Systems",
        "value": "dueDiligenceSystems",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      },
      {
        "label": "Investigation & Research",
        "value": "investigation&Research",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      },
      {
        "label": "Legalisation",
        "value": "legalisation",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      },
      {
        "label": "Policy & Enforcement",
        "value": "policy&Enforcement",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      },
      {
        "label": "Social Program",
        "value": "socialProgram",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      },
      {
        "label": "Advocacy",
        "value": "advocacy"
      },
      {
        "label": "Infrastructure",
        "value": "infrastructure",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      },
      {
        "label": "Equipment Provision",
        "value": "equipmentProvision",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      },
      {
        "label": "Technical Intervention",
        "value": "technicalIntervention",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      },
      {
        "label": "Financial Intervention",
        "value": "financialIntervention",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      },
      {
        "label": "Commercial Intervention",
        "value": "commercialIntervention",
        "filters": [
          {
            "name": "vulnerabilityLevel",
            "condition": "not",
            "value": 5
          }
        ]
      }
    ]
  }
}
